var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayout',{staticClass:"base",scopedSlots:_vm._u([{key:"main",fn:function(){return [_vm._t("main")]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }